import React, { useState, useContext, useEffect, Fragment } from "react";
import PropTypes from "prop-types";
import classNames from "classnames/bind";
import { CameraContext } from "../../LiveCamera/LiveCamera";
import Camera from "./Camera";
import styles from "./WeraHouse.module.css";
import axiosClient from "../../../services/axiosClient";
import streamingClient from "../../../services/streamingClient";
import { useStoreContext } from "../../../hooks/useStoreContext";
import { actions } from "../../../store";
import { changeDataCam } from "../../../utils";

const cx = classNames.bind(styles);
const WareHouse = ({
  icon,
  name,
  show,
  parentShow,
  onClick,
  code,
  status,
  groupCode,
}) => {
  const { setIsApply, oneThread } = useContext(CameraContext);
  const [camera, setCamera] = useState([]);
  const [dataCamera, setDataCamera] = useState();
  const [size, setSize] = useState(1);
  const [pageEnd, setPageEnd] = useState(false);
  const [check, setCheck] = useState(false);
  const [dataStore, dispatch] = useStoreContext();
  const [isChange, setIsChange] = useState(false)

  const checkStatus = (status) => {
    if (status !== 'all') {
      return true;
    } else {
      return false;
    }
  };
  const getListStatus = async (data) => {
    try {
      const filter = data.map((item) => {
        return item.CAMERA.CODE;
      });
      let json = JSON.stringify({ data: filter });
      if (filter.length > 0) {
        const res = await streamingClient.post(
          "/streamManagement/post-state-list-camera-stream/",
          {
            list_camera_code: filter,
          }
        );
        return res.result;
      }
      return [];
    } catch (e) { }
  };
  useEffect(() => {
    if (!pageEnd) {
      const getListCameraByCode = async () => {
        const res = await axiosClient.get(
          `cameraManagement/get-list-camera/?page=${size}&size=1000&warehouse_code=${code}`,
          {
            params: {
              status_active: checkStatus(status) ? status : null,
              group_code: groupCode ? groupCode : null,
            },
          }
        );
        const data = changeDataCam(res);
        const camera = data.data;
        setDataCamera(camera);
        if (res.data.length > 0) {
          setCamera((prev) => [...prev, ...camera]);
        } else {
          setPageEnd(true);
        }
      };
      getListCameraByCode();
    }
  }, [code, status, groupCode]);
  const handleChange = (e) => {
    setCheck(e.target.checked);
    setIsChange(true)
    if (e.target.checked) {
      setIsApply(true);
      dataCamera?.forEach((item) => {
        // if (item.CAMERA.STATUS === 'On') {
        dispatch(
          actions.getListCameraPriority({
            camera_code: item.CAMERA.CODE,
            status_priority: "1",
          })
        );
        // }
      });
    } else {
      setIsApply(true);
      dataCamera?.forEach((item) => {
        // if (item.CAMERA.STATUS === 'On') {
        dispatch(
          actions.getListCameraPriority({
            camera_code: item.CAMERA.CODE,
            status_priority: "0",
          })
        );
        // }
      });
    }
  };

  const onClicks = (data) => {
    onClick(data);
    
  };
  useEffect(() => {
    const tick = dataCamera?.every((item) => item.CAMERA.PRIORITIZED === "1");
    setCheck(tick);
  }, [dataCamera]);
  const handleScrollBar = (e) => {
    if (
      e.currentTarget.scrollHeight - e.currentTarget.scrollTop <=
      e.target.clientHeight + 10 &&
      !pageEnd
    ) {
      setSize(size + 1);
    }
  };

  // chay show
  useEffect(() => {
    const codeWareHouse = dataStore.wareHouses.indexWareHouse;
    if (codeWareHouse) {
      onClicks(codeWareHouse);
    }
    // eslint-disable-next-line
  }, [dataStore.wareHouses.indexWareHouse]);
  return (
    <div className={cx("item")}>
      <div onClick={(e) => onClicks(code)} className={cx("location")}>
        <span className={cx("icon")}>{icon}</span>
        <span className={cx("name")}>{name}</span>
      </div>
      {!oneThread && (
        <input
          onChange={handleChange}
          checked={check}
          className={cx("check")}
          type="checkbox"
          value={check}
        />
      )}
      {parentShow && show && (
        <div className={cx("warehouse")} onScroll={handleScrollBar}>
          {camera &&
            camera.map((item, index) => (
              <Fragment key={index}>
                <Camera
                  check={check}
                  status={item.CAMERA?.STATUS_ACTIVE}
                  name={item.CAMERA?.NAME_CAM}
                  camID={item.CAMERA?.CODE}
                  setCheck={setCheck}
                  prioritized={item.CAMERA.PRIORITIZED}
                  isChange={isChange}
                  setIsChange={setIsChange}
                  message={item.CAMERA.MESSAGE}
                  index={index}
                />
              </Fragment>
            ))}
        </div>
      )}
    </div>
  );
};
WareHouse.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  show: PropTypes.bool.isRequired,
  parentShow: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};
export default WareHouse;
